<script setup lang="ts">
// Aurora 颗粒噪声覆盖层。SVG feTurbulence 走 data-url 内联，零网络请求。
// 与 AuroraBg 解耦，可单独挂在 App.vue —— 让"前景"也带颗粒，避免被高 z-index 内容盖死。
const props = withDefaults(defineProps<{ opacity?: number; blendMode?: string }>(), {
  opacity: 0.08,
  blendMode: 'overlay',
});
</script>

<template>
  <div
    aria-hidden
    class="aurora-grain"
    :style="{ opacity: props.opacity, mixBlendMode: props.blendMode as never }"
  />
</template>

<style scoped>
.aurora-grain {
  position: fixed;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background-image: url("data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
}
</style>
